import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/restricted/profile/ProfileDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      menuSelected: 'profile'
    }
  },
  {
    path: '/profile/collaborators/:collaboratorId/edit',
    name: 'profileCollaborator',
    component: () => import('@/views/restricted/profile/ProfileCollaboratorView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      menuSelected: 'profile'
    }
  }
]
